import { styled } from '@mui/material';

const ForecasterHeader = styled('div')(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  width: '100%',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingRight: '17px',
  '&::after': {
    content: '""',
    position: 'absolute',
    right: 0,
    height: '30px',
    width: '1px',
    backgroundColor: theme.palette.divider,
  },
}));

export default ForecasterHeader;
